import { cx } from '@flowus/common/cx';
import { GoogleAdSense, PromotionCarouselAd } from '@flowus/common/components';
import { DEFAULT_FONT_FAMILY } from '@flowus/common/style';
import type { FC } from 'react';
import { promotionChannel, publicLink } from 'src/common/const';
import { ossImagesPath } from 'src/image';
import { bizTracker } from 'src/utils/biz-tracker';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PRODUCT_ALL_NAME } from 'src/const/title';
import { usePageMeta } from 'src/hooks/page/use-page-meta';
import { useOfficialSpaceShare } from 'src/hooks/public/use-official-space-share';
import { useIsOwner } from 'src/hooks/share/use-owner';
import { usePermissions } from 'src/hooks/share/use-permissions';
import { useReportIllegal } from 'src/hooks/share/use-report-illegal';
import { useIsShowAd } from 'src/hooks/space/use-is-pro-space';
import { useFileIllegal } from 'src/services/app';
import { $searchParams } from 'src/utils';
import { isEmbedTemplate, judgeSharePage, useGetPageId } from 'src/utils/getPageId';
import { usePickBlock } from 'src/utils/pick-block';
import { PageScene, usePageScene } from 'src/views/main/scene-context';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const Footer: FC<{ logo?: boolean; className?: string; addSpace?: boolean }> = (props) => {
  const { t } = useAppTranslation();
  const pageId = useGetPageId();
  const report = useReportIllegal();
  const isOwner = useIsOwner();
  const block = usePickBlock(pageId, []);
  const pageMeta = usePageMeta(pageId);
  const isShowAd = useIsShowAd(block?.spaceId);
  // const isProSpace = useIsProSpace(block?.spaceId);
  const fileIllegal = useFileIllegal();
  const pageScene = usePageScene();
  // 被风控了
  const { illegal } = usePermissions(pageId);
  // 特殊空间
  const officialSpaceShare = useOfficialSpaceShare(pageId);
  const isHiddenReport =
    isOwner ||
    pageMeta?.tag === 'NO_PERMISSION' ||
    pageMeta?.tag === 'NOT_FOUND' ||
    fileIllegal ||
    officialSpaceShare;
  if (!judgeSharePage() || officialSpaceShare || pageScene === PageScene.FORM_ENG_PAGE) {
    return <div className="footer h-[15vh] flex-shrink-0" />;
  }

  if (isEmbedTemplate) return null;

  const showAd = !illegal && isShowAd;

  const showReport = !isHiddenReport;

  if (!showAd && !showReport) return <div className="mt-20" />;

  if ($searchParams.blog) return null;

  if (__PRIVATE__) return null;

  return (
    <footer
      className={cx(
        'footer flex flex-col items-center w-full max-w-[1420px] mx-auto flex-shrink-0 bg-white1 mt-20 line-default justify-center border-t',
        props.className
      )}
      style={{
        fontFamily: DEFAULT_FONT_FAMILY,
      }}
    >
      <div className="flex w-full max-w-4xl flex-col items-center justify-center px-10">
        {showAd &&
          (__BUILD_IN__ ? (
            <GoogleAdSense enabled={__ENABLE_ADSENSE__} className="max-w-[960px] mt-2.5" />
          ) : (
            <PromotionCarouselAd
              Swiper={Swiper}
              SwiperSlide={SwiperSlide}
              autoplay={{ delay: 8000 }}
              modules={[Autoplay]}
              className="max-w-[960px] mt-2.5"
              href={promotionChannel}
              onClick={() => {
                bizTracker.event('web_bottom_bar');
              }}
              imageUrls={[...Array(3).keys()].map(
                (item) => `${ossImagesPath}/footer/footer-${item}.png`
              )}
              imgClassName="inline h-full max-h-[150px] w-full rounded-[10px]"
            />
          ))}
        <div
          className={cx(
            'text-t3 text-grey3 my-5 flex justify-end w-full',
            isShowAd && 'justify-between'
          )}
        >
          <div hidden={!isShowAd}>
            {t('common.by_prefix')}
            <a href={publicLink.learnMore} className="mx-1 text-black">
              {PRODUCT_ALL_NAME}
            </a>
            {t('common.footer.powered_by_suffix')}
          </div>
          <div>
            {showReport && (
              <div className="flex whitespace-nowrap flex-shrink-0">
                {t('common.footer.report_prefix')}
                <div className="ml-0.5 animate-click underline underline-offset-3" onClick={report}>
                  {t('common.footer.report_link')}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {props.addSpace && <div className="h-[120px] w-full"></div>}
    </footer>
  );
};
